import { LearningItemStatus } from '../../models/BaseModels'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

type CreateScheduledCourseArgs = {
  status: LearningItemStatus
  title: string
  description: string
  image: string | null | undefined
  categoryUuids: string[]
  providerUuid: string | null | undefined
  isGlobalProvider: boolean
  clientUuid: string | null | undefined
  createCertificate: boolean
  certificateValidUntil: Date | null | undefined
  events: {
    maxAttendees: number
    dates: {
      title: string
      trainers: string[]
      startDate: Date
      endDate: Date
      meetingLink: string | null | undefined
      meetingAddress: string | null | undefined
    }[]
  }[]
}

export default function useCreateScheduledCourse() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: CreateScheduledCourseArgs) => {
      const result = api.post('scheduled-course', {
        status: data.status,
        title: data.title,
        description: data.description,
        image: data.image || undefined,
        categories: data.categoryUuids,
        provider_uuid: data.providerUuid,
        is_global_provider: data.isGlobalProvider,
        client_uuid: data.clientUuid,
        create_certificate: data.createCertificate,
        certificate_valid_until: data.certificateValidUntil,
        events: data.events.map((event) => ({
          max_attendees: event.maxAttendees,
          dates: event.dates.map((date) => ({
            title: date.title,
            trainer: date.trainers,
            start_date: date.startDate,
            end_date: date.endDate,
            meeting_link: date.meetingLink,
            address: date.meetingAddress,
          })),
        })),
      })

      await invalidate.courses()

      return result
    },
  })
}
